import { useState, useEffect, useRef } from "react";
import { AiFillDelete } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import useFetchWithAuthorization from "../Apis/useFetchWithAuthorization";

const Cart = ({  handleRemoveFromCarts, hidecart, handleRemoveAllFromCart  }) => {
  const navigate = useNavigate(); // Initialize the useNavigate hook
  const [user, setUser] = useState(false);

  const cartItemsFromStorage = localStorage.getItem('cartItems');
  // console.log(cartItemsFromStorage);
  const [cartItems, setCartItems] = useState(cartItemsFromStorage ? JSON.parse(cartItemsFromStorage) : []);
  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(cartItems));
  }, [cartItems]);
 console.log(cartItems);
  //when item is removed from the cart
  const handleRemoveFromCart = (index) => {
    const updatedCartItems = [...cartItems];
    updatedCartItems.splice(index, 1); // Remove the item at the specified index
    
    setCartItems(updatedCartItems); // Update the cartItems state
    
    // Update the local storage
    localStorage.setItem('cartItems', JSON.stringify(updatedCartItems));
  };
  


  const handleClickInsideCart = (event) => {
    event.stopPropagation(); // Stop event propagation (bubbling)
  };
  //check if the user is logged in
  const { data, loading, error } = useFetchWithAuthorization("https://campus-closet-server.vercel.app/profile");
  useEffect(() => {
    if (data) {
      setUser(true)
    }
  }, [data]);
  // console.log("There is user:" +user);
const handleSubmit=(()=>{
  //if user is not logged in
if (!user) {
  window.alert("You need to login first")
  hidecart()
  navigate("/login");
}
else{
  hidecart()
  handleRemoveAllFromCart()
  navigate("/order", { state: { cartItems } }); // Pass the cartItems as state
}
})
  return (
    
    <div onClick={handleClickInsideCart} className="absolute left-[10%] top-20 sm:left-[50%] md:left-[65%] lg:left-[70%]  md:top-14 z-10 bg-white text-gray-800 shadow-lg w-[300px] h-[250px] md:w-[250px] md:h-[200px] rounded-md overflow-scroll">
      <div className="h-10 border">
        <h1>Cart</h1>
        {!cartItems.length ? (
          <div className="flex w-full h-44 justify-center items-center">
            <p>Your cart is empty</p>
          </div>
        ) : (
          <div>
            {cartItems.map((item, index) => (
              <div className="flex justify-between px-2 pt-7" key={index}>
                <div className="14 h-14 rounded bg-slate-500">
                  <img
                    className="w-14 h-14 rounded"
                    src={item.image}
                    alt={item.description}
                  />
                </div>
                <div className="w-40">
                  <h2>{item.product_name}</h2>
                  <h2 className="font-bold">KSh {item.price}</h2>
                </div>
                <AiFillDelete
                  onClick={() => {
                    handleRemoveFromCart(index)
                    handleRemoveFromCarts(index)
                  }}
                  size={20}
                  className="text-slate-500 cursor-pointer"
                />
              </div>
            ))}
            <button onClick={handleSubmit} disabled={loading} className="bg-orange-500 text-white w-52 py-2 rounded-md mt-3 ml-2 mb-2">
            {loading ? "Loading..." : "Checkout"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default Cart;
